// extracted by mini-css-extract-plugin
export default {"title_curriculum":"styles_title_curriculum__d304u"};